export default __webpack_public_path__ + "static/media/informations reçues sur le patrimoine immatériel.3a8d7683.svg";